import isLoaderActive from 'editor/src/store/app/selector/isLoaderActive';
import { addLoaderAction, removeLoaderAction } from 'editor/src/store/app/slice';
import { LoaderType } from 'editor/src/store/app/types';
import getDesignColorSpace from 'editor/src/store/design/selector/getDesignColorSpace';
import { setDesignColorSpaceAction } from 'editor/src/store/design/slice';
import { ColorSpace } from 'editor/src/store/design/types';
import type { AsyncThunk } from 'editor/src/store/hooks';

import { captureException } from 'editor/src/logger';
import { getModule, loadLittleCMSModule } from 'editor/src/util/color/cmykUtils/littleCMSModule';

// Every choice takes a ticket, so a click made while a CMYK switch still waits for the profile
// wins over that switch, even a click on the colour space the design already has.
let latestRequest = 0;

const setDesignColorSpaceOperation =
  (colorSpace: ColorSpace): AsyncThunk =>
  async (dispatch, getState) => {
    latestRequest += 1;
    const request = latestRequest;
    const isCurrent = colorSpace === getDesignColorSpace(getState());
    // A CMYK value entered before the print profile loads gets its screen colour from the rough
    // fallback formula, and that hex is stored with it — so the swatch would not match the print.
    const waitsForProfile = colorSpace === ColorSpace.CMYK && !isCurrent && !getModule();
    if (!waitsForProfile && isLoaderActive(getState(), LoaderType.ColorSpaceSwitch)) {
      dispatch(removeLoaderAction(LoaderType.ColorSpaceSwitch));
    }
    if (isCurrent) {
      return;
    }
    if (waitsForProfile) {
      // Both colour-space controls show CMYK as chosen, with a spinner, until the switch lands.
      dispatch(addLoaderAction(LoaderType.ColorSpaceSwitch));
      try {
        await loadLittleCMSModule();
      } catch (error) {
        captureException(error);
      }
      if (request !== latestRequest) {
        return;
      }
    }
    dispatch(setDesignColorSpaceAction(colorSpace));
    if (waitsForProfile) {
      dispatch(removeLoaderAction(LoaderType.ColorSpaceSwitch));
    }
  };

export default setDesignColorSpaceOperation;
